import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface DashboardFilterState {
  ReportFilterType: number,
  QuarterlyYearType: number,
  HalfYearType: number,
  Month: number,
  FinancialYearRef: number,
  IncentiveRole: number,
  FromDate: string,
  ToDate: string,

  AnemiaMuktaBharatType: number,
  ContraceptivePillType: number,
  ContraceptivePillTypeName?: string,
  AnemiaMuktaBharatTabletclickedItem: string,
  IncentiveType: number,
  Title: string,

  state_ids: number[];
  zone_ids: number[];
  district_ids: number[];
  block_ids: number[];
  phc_ids: number[];
  af_ids: number[];
  sc_ids: number[];
  village_ids: number[];
  asha_ids: number[];
  DCMPostRefs: number[];
  bcm_post_ids: number[];
  asha_employee_record_ids: number[];
  af_employee_record_ids: number[];
  bcm_employee_record_ids: number[];
}

@Injectable({ providedIn: 'root' })
export class DashboardFilterStateStorageService {

  private filterStateSubject = new BehaviorSubject<DashboardFilterState>({
    ReportFilterType: 0,
    QuarterlyYearType: 0,
    HalfYearType: 0,
    Month: 0,
    FinancialYearRef: 0,
    IncentiveRole: 0,
    FromDate: '',
    ToDate: '',
    state_ids: [],
    zone_ids: [],
    district_ids: [],
    block_ids: [],
    phc_ids: [],
    af_ids: [],
    sc_ids: [],
    village_ids: [],
    asha_ids: [],
    DCMPostRefs: [],
    bcm_post_ids: [],
    asha_employee_record_ids: [],
    af_employee_record_ids: [],
    bcm_employee_record_ids: [],
    Title: '',
    AnemiaMuktaBharatType: 0,
    ContraceptivePillType: 0,
    IncentiveType: 0,
    AnemiaMuktaBharatTabletclickedItem: ''
  });

  filterState$ = this.filterStateSubject.asObservable();

  // SET
  setFilterState(state: Partial<DashboardFilterState>) {
    const current = this.filterStateSubject.value;
    this.filterStateSubject.next({ ...current, ...state });
  }

  // GET snapshot
  getFilterState(): DashboardFilterState {
    console.log('this.filterStateSubject.value :', this.filterStateSubject.value);
    return this.filterStateSubject.value;
  }

  // Update single field
  updateField<K extends keyof DashboardFilterState>(
    key: K,
    value: DashboardFilterState[K]
  ) {
    const current = this.filterStateSubject.value;
    this.filterStateSubject.next({ ...current, [key]: value });
  }

  // CLEAR
  clearFilterState() {
    this.filterStateSubject.next({
      ReportFilterType: 0,
      QuarterlyYearType: 0,
      HalfYearType: 0,
      Month: 0,
      FinancialYearRef: 0,
      IncentiveRole: 0,
      FromDate: '',
      ToDate: '',
      Title: '',


      state_ids: [],
      zone_ids: [],
      district_ids: [],
      block_ids: [],
      phc_ids: [],
      af_ids: [],
      sc_ids: [],
      village_ids: [],
      asha_ids: [],
      DCMPostRefs: [],
      bcm_post_ids: [],
      asha_employee_record_ids: [],
      af_employee_record_ids: [],
      bcm_employee_record_ids: [],

      AnemiaMuktaBharatType: 0,
      AnemiaMuktaBharatTabletclickedItem: '',
      IncentiveType: 0,
      ContraceptivePillType: 0,
    });
  }
}